import React from 'react';
import PaymentInfo from 'pages/FreeTrialActivation/components/PaymentInfo';
import InviteTeam from 'pages/FreeTrialActivation/components/InviteTeam';
import SetupComplete from 'pages/FreeTrialActivation/components/SetupComplete';
import { FreeTrialOnboardingProvider } from 'pages/FreeTrialActivation/components/FreeTrialOnboardingContext';
import { Box, Dialog } from '@mui/material';
import DashboardBg from 'assets/DashboardBg.png';

export type OnboardingDialogProps = {
  orgInfoToken: string;
  handleSilentLogin: (token?: string) => void;
};

export default function OnboardingDialog({
  orgInfoToken,
  handleSilentLogin,
}: OnboardingDialogProps) {
  const [onboardingStep, setOnboardingStep] = React.useState(0);

  return (
    <FreeTrialOnboardingProvider>
      <Box
        sx={{
          minHeight: '100vh',
          minWidth: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 0,
          backgroundImage: `url(${DashboardBg})`,
          backgroundSize: 'cover',
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Dialog
          open
          maxWidth={false}
          PaperProps={{
            sx: {
              borderRadius: '24px',
              background: '#FFF',
              boxShadow:
                '0 11px 15px -7px rgba(0,0,0,0.20), 0 24px 38px 3px rgba(0,0,0,0.14), 0 9px 46px 8px rgba(0,0,0,0.12)',
              width: {
                xs: '100vw',
                sm: onboardingStep === 0 ? '1200px' : '800px',
              },
              minHeight: { xs: '100vh', sm: 'auto' },
              flexDirection: 'column',
              p: 0,
              m: 0,
              maxWidth: '100vw',
              maxHeight: '100vh',
              overflow: 'auto',
            },
          }}
        >
          {onboardingStep === 0 && (
            <PaymentInfo
              key='payment'
              onNext={() => setOnboardingStep(2)}
              token={orgInfoToken}
              step={2}
              totalSteps={4}
            />
          )}
          {onboardingStep === 1 && (
            <InviteTeam
              key='invite'
              onNext={() => setOnboardingStep(3)}
              step={3}
              totalSteps={4}
              token={orgInfoToken}
            />
          )}
          {onboardingStep === 2 && (
            <SetupComplete
              key='complete'
              onSilentLogin={() => handleSilentLogin(orgInfoToken)}
            />
          )}
        </Dialog>
      </Box>
    </FreeTrialOnboardingProvider>
  );
}
